/*
* Copyright 2014-2021 JetBrains s.r.o and contributors. Use of this source code is governed by the Apache 2.0 license.
*/

package io.ktor.utils.io

/**
 * Print exception stacktrace.
 */
public actual fun Throwable.printStack() {
    @Suppress("UnsafeCastFromDynamic")
    println(asDynamic().stack)
}
